import { render, staticRenderFns } from "./article_sortie.vue?vue&type=template&id=4c9713c4&scoped=true&"
import script from "./article_sortie.vue?vue&type=script&lang=js&"
export * from "./article_sortie.vue?vue&type=script&lang=js&"
import style0 from "./article_sortie.vue?vue&type=style&index=0&id=4c9713c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9713c4",
  null
  
)

export default component.exports